import { SortOrder } from '../../models/component/FiltersModel/types'

export function compareString(valueA: string, valueB: string, sortOrder: SortOrder): number {
  valueA = (valueA || '').toUpperCase()
  valueB = (valueB || '').toUpperCase()
  if (sortOrder === SortOrder.ASC) {
    return (valueA < valueB) ? -1 : (valueA > valueB) ? 1 : 0
  } else {
    return (valueA > valueB) ? -1 : (valueA < valueB) ? 1 : 0
  }
}

export function compareNumbers(valueA: number, valueB: number, sortOrder: SortOrder): number {
  if (sortOrder === SortOrder.ASC) {
    return valueA - valueB
  } else {
    return valueB - valueA
  }
}